import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { faFacebookF, faInstagram, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const Footer = () => {
    return (
        <footer className='py-5 custom-bg'>
            <div className="container text-white">
                <Row xs={1} md={2} lg={3} className="g-4">
                    <Col>
                        <div className='px-3'>
                            <h2>Amer Bari</h2>
                            <p>রাজশাহী এবং চাঁপাইনবাবগঞ্জের ফরমালিনমুক্ত অরগানিক আমের বিশাল সমাহার পাবেন আমের বাড়িতে, আমাদের নিজেদের তত্ত্বাবধানে সম্পূর্ণ প্রাকৃতিক উপায়ে বেড়ে ওঠা গাছ পাকা আম পেতে আমাদের আমাদের সাথে যোগাযোগ করুন।</p>
                        </div>
                    </Col>

                    <Col>
                        <div className='px-3'>
                            <h2>যোগাযোগ :</h2>
                            <p className='m-0'>Aman Ullah</p>
                            <p className='m-0'>Phone: 01774659710</p>
                            <p className='m-0'>Hridoy</p>
                            <p className='m-0'>Phone: 01703695796</p>
                        </div>
                    </Col>

                    <Col>
                        <div className='px-3'>
                            <h2>Social Link</h2>
                            <div className="d-flex">
                                <a href="https://www.facebook.com/amerbari007/">
                                    <div className='footer-icon'>
                                        <FontAwesomeIcon icon={faFacebookF} />
                                    </div>
                                </a>
                                <a href="https://www.facebook.com/amerbari007/">
                                    <div className='footer-icon'>
                                        <FontAwesomeIcon icon={faInstagram} />
                                    </div>
                                </a>
                                <a href="https://www.facebook.com/amerbari007/">
                                    <div className='footer-icon'>
                                        <FontAwesomeIcon icon={faTwitter} />
                                    </div>
                                </a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </footer>
    );
};

export default Footer;
